/* eslint-disable no-await-in-loop */
document.addEventListener('DOMContentLoaded', async () => {
	const cartItems = await fetchCartItems();
	await syncCheckboxesAndCartItems(cartItems);
	document.querySelectorAll('.add-installation-label').forEach((label) => {
		label.removeAttribute('hidden');
	});
	const checkboxes = document.querySelectorAll('.add-installation-checkbox');

	for (const checkbox of checkboxes) {
		const variantKey = checkbox.getAttribute('data-variant-key');
		const matchedVariant = cartItems.find(
			(item) => item.properties?._relatedInstallationVariantKey === variantKey
		);

		await updateCheckboxQuantity(checkbox, matchedVariant);
		checkbox.addEventListener('click', async () => {
			await handleAddToCartClick(cartItems, checkbox);
		});
	}
	
});

async function fetchCartItems() {
	try {
		const response = await fetch(window.Shopify.routes.root + 'cart.js');

		if (!response.ok) {
			throw new Error(
				`Failed to fetch cart: ${response.status} ${response.statusText}`
			);
		}

		const data = await response.json();

		if (!data || !data.items) {
			return [];
		}

		return data.items;
	} catch (error) {
		console.error('Error fetching cart:', error);
		return [];
	}
}

async function syncCheckboxesAndCartItems(cartItems) {
	const variantKeysInCart = new Set(cartItems.map((item) => item.key));

	for (const cartItem of cartItems) {
		const relatedInstallationVariantKey =
      cartItem.properties?._relatedInstallationVariantKey;

		if (!relatedInstallationVariantKey) {
			continue;
		}

		const matchingCheckbox = document.querySelector(
			`.add-installation-checkbox[data-variant-key="${relatedInstallationVariantKey}"]`
		);

		if (!variantKeysInCart.has(relatedInstallationVariantKey)) {
			// Passing 0 to remove the product from the cart
			// eslint-disable-next-line no-magic-numbers
			await changeCartItemQuantity(cartItem.key, 0);
			redirectToCart();
		} else if (matchingCheckbox) {
			matchingCheckbox.checked = true;
		}
	}
}

async function updateCheckboxQuantity(checkbox, matchedVariant) {
	if (!matchedVariant) {
		return;
	}

	const quantity = Number(checkbox.getAttribute('data-quantity'));
	const matchedQuantity = Number(matchedVariant.quantity);

	if (checkbox.checked && quantity !== matchedQuantity) {
		await changeCartItemQuantity(matchedVariant.key, quantity);
		redirectToCart();
	}
}

async function handleAddToCartClick(cartitems, checkbox) {
	const variantKey = checkbox.getAttribute('data-variant-key');

	if (checkbox.checked) {
		return handleAddInstallation(checkbox, variantKey);
	}
	return handleRemoveInstallation(cartitems, checkbox, variantKey);
}

async function handleAddInstallation(checkbox, variantKey) {
	const installationModal = document.getElementById(
		'modal-add-installation-confirm'
	);
	const okButton = document.getElementById('modal-add-installation-confirm-ok');
	const cancelButton = document.getElementById(
		'modal-add-installation-confirm-cancel'
	);

	installationModal.classList.remove('hide-add-installation-confirm-modal');

	const onOkClick = async () => {
		closeModal();
		await proceedWithInstallation(checkbox, variantKey);
	};

	const onCancelClick = () => {
		closeModal();
		checkbox.checked = false;
	};

	okButton.addEventListener('click', onOkClick);
	cancelButton.addEventListener('click', onCancelClick);

	function closeModal() {
		installationModal.classList.add('hide-add-installation-confirm-modal');
		okButton.removeEventListener('click', onOkClick);
		cancelButton.removeEventListener('click', onCancelClick);
	}
}

async function proceedWithInstallation(checkbox, variantKey) {
	const productTitle = checkbox.getAttribute('data-product-title');
	const quantity = checkbox.getAttribute('data-quantity');
	const price = checkbox.value;

	const formData = {
		items: [
			{
				id: 51641181602161, // Permanent Variant ID for installation product
				quantity: quantity,
				properties: {
					התקנה: `עבור ${productTitle}`,
					// Convert agorot to shekels
					// eslint-disable-next-line no-magic-numbers
					_price: `${price / 100}`,
					_relatedInstallationVariantKey: variantKey,
				},
			},
		],
	};

	try {
		await fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(formData),
		});
		redirectToCart();
	} catch (error) {
		console.error('Error adding item:', error);
	}
}

async function handleRemoveInstallation(cartItems, checkbox, variantKey) {
	const installationModal = document.getElementById('modal-remove-installation-confirm');
	const okButton = document.getElementById('modal-remove-installation-confirm-ok');
	const cancelButton = document.getElementById('modal-remove-installation-confirm-cancel');
	installationModal.classList.remove('hide-remove-installation-confirm-modal');

	const onOkClick = async () => {
		closeModal();
		await proceedWithRemoval(cartItems, checkbox, variantKey);
	};

	const onCancelClick = () => {
		closeModal();
		checkbox.checked = true;
	};

	okButton.addEventListener('click', onOkClick);
	cancelButton.addEventListener('click', onCancelClick);

	function closeModal() {
		installationModal.classList.add('hide-remove-installation-confirm-modal');
		okButton.removeEventListener('click', onOkClick);
		cancelButton.removeEventListener('click', onCancelClick);
	}
}

async function proceedWithRemoval(cartItems, checkbox, variantKey) {
	const matchedVariant = cartItems.find(
		(item) =>
			item.properties &&
			item.properties._relatedInstallationVariantKey === variantKey
	);

	if (matchedVariant) {
		// Passing 0 to remove the product from the cart
		// eslint-disable-next-line no-magic-numbers
		await changeCartItemQuantity(matchedVariant.key, 0);
		checkbox.closest('.add-installation-label').removeAttribute('hidden');
		checkbox.checked = false;
		redirectToCart();
	}
}


async function changeCartItemQuantity(key, quantity) {
	try {
		const response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				id: key,
				quantity,
			}),
		});

		if (!response.ok) {
			throw new Error(`Error changing item quantity: ${response.status}`);
		}
	} catch (error) {
		console.error('Error changing item quantity in cart:', error);
	}
}

function redirectToCart() {
	window.location.href = '/cart';
}
